import { createContext } from 'react';

const MapContext = createContext<boolean>(false);

export default MapContext;
